export default "__VITE_ASSET__e5452e51__"